// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const popularSearchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPopularSearch: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/popular-search/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: (result, error) => [{ type: "PopularSearch" }],
    }),
    getPopularSearchCategories: builder.query({
      query: () => "/api/v1/admin/popular-search/category",
      providesTags: (result, error) => [{ type: "PopularSearchCategory" }],
    }),
    createPopularSearch: builder.mutation({
      query: (data) => {
        return {
          url: "/api/v1/admin/popular-search",
          method: "POST",
          body: data,
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        };
      },
      invalidatesTags: ["PopularSearch"],
    }),

    getPopularSearchById: builder.query({
      query: (id) => `/api/v1/admin/popular-search/${id}`,
      providesTags: (result, error, id) => [{ type: "PopularSearch", id }],
    }),

    updatePopularSearch: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/api/v1/admin/popular-search/${id}`,
          method: "PATCH",
          body: data,
        };
      },
      invalidatesTags: ["PopularSearch"],
    }),

    deletePopularSearch: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/popular-search/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PopularSearch"],
    }),
  }),
});

export const {
  useGetPopularSearchQuery,
  useCreatePopularSearchMutation,
  useUpdatePopularSearchMutation,
  useGetPopularSearchByIdQuery,
  useDeletePopularSearchMutation,
  useGetPopularSearchCategoriesQuery,
} = popularSearchApiSlice;
